import Danger from "../../icons/danger";

/**
 * @param {string} invalidMessage message displayed when input is invalid
 * @param {string} validMessage message displayed when input is valid
 * 
 * @param {bool} textInputIsValid [Required] if set to true the text-input is valid
 *                                          if set to false the text-input is invalid
 */
function ValidationFeedback(props){

    let invalidMessage = null;
    let validMessage = null;
    let dangerIcon;

    if (props.invalidMessage !== undefined && props.textInputIsValid === false) {
        invalidMessage = props.invalidMessage;
        dangerIcon = (
            <Danger />
        )
    }

    if (props.validMessage !== undefined) {
        validMessage = props.validMessage;
    }

    return(    
        <>    
            <div className="invalid-feedback">
                {dangerIcon} {invalidMessage}
            </div>
            <div className="valid-feedback">
                {validMessage}
            </div>
        </>
    )
}

export default ValidationFeedback;